import React from 'react';

const LoadingSpinner = ({ 
  size = 'medium', 
  color = 'primary', 
  text = null,
  overlay = false 
}) => {
  // Size configurations
  const sizeClasses = {
    small: 'w-4 h-4',
    medium: 'w-8 h-8',
    large: 'w-12 h-12',
    xlarge: 'w-16 h-16'
  };

  // Color configurations
  const colorClasses = {
    primary: 'border-primary-600',
    white: 'border-white',
    gray: 'border-gray-600',
    medical: 'border-medical-blue'
  };

  const spinnerClasses = `
    ${sizeClasses[size]} 
    border-2 border-t-transparent 
    ${colorClasses[color]} 
    rounded-full 
    animate-spin
  `.trim();

  const containerClasses = `
    ${overlay ? 'fixed inset-0 bg-black bg-opacity-50 z-50' : ''}
    flex flex-col items-center justify-center
    ${text ? 'gap-md' : ''}
  `.trim();

  const textClasses = `
    text-sm font-medium
    ${color === 'white' ? 'text-white' : 'text-gray-600'}
  `.trim();

  return (
    <div className={containerClasses}>
      <div className={spinnerClasses}></div>
      {text && (
        <div className={textClasses}>
          {text}
        </div>
      )}
    </div>
  );
};

// Specialized loading components for different contexts
export const AudioProcessingSpinner = ({ text = "Processing audio..." }) => (
  <LoadingSpinner 
    size="large" 
    color="primary" 
    text={text}
  />
);

export const OverlaySpinner = ({ text = "Loading..." }) => (
  <LoadingSpinner 
    size="large" 
    color="white" 
    text={text}
    overlay={true}
  />
);

export const InlineSpinner = ({ size = "small" }) => (
  <LoadingSpinner size={size} color="primary" />
);

export const RecordingSpinner = ({ text = "Recording..." }) => (
  <div className="flex items-center gap-sm">
    <div className="w-3 h-3 border-2 border-recording-active border-t-transparent rounded-full animate-spin"></div>
    <span className="text-sm font-medium text-recording-active animate-pulse">
      {text}
    </span>
  </div>
);

export default LoadingSpinner;